module.exports = __webpack_public_path__ + "static/SingleLeg-Lunge-96bedb90bf52dc347f62c4a1f88ca1a0.mp4";